import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { hostedVideoActions } from '..';

import { HostedVideoActions, HostedVideoState } from './../types';
import checkUploadReducer from './checkUploadReducer';
// import createVideoReducer from './createVideoReducer';
import deleteVideoReducer from './deleteVideoReducer';
import embedVideoReducer from './embedVideoReducer';
import getHostedVideoFoldersReducer from './getHostedVideoFoldersReducer';
import getManifestReducer from './getManifestReducer';
import replaceVideoReducer from './replaceVideoReducer';
import saveVideoConfigsReducer from './saveVideoConfigsReducer';
import saveVideoPasswordReducer from './saveVideoPasswordReducer';
import uploadPosterReducer from './uploadPosterReducer';
// import uploadVideoReducer from './uploadVideoReducer';
import videoDataReducer from './videoDataReducer';

const defaultResponseState = {
  isPending: false,
  isError: false
};

export const initialHostedVideoState: HostedVideoState = {
  id: null,
  list: null,
  upload: null,
  canNotify: true,
  videoData: null,
  embedVideo: {
    data: null,
    status: false
  },
  createVideo: defaultResponseState,
  deleteVideo: defaultResponseState,
  uploadVideo: {
    progress: null,
    isUploaded: false,
    isCanceled: false,
    ...defaultResponseState
  },
  saveVideoConfigs: defaultResponseState,
  saveVideoPassword: defaultResponseState,
  getManifest: {
    manifest: null,
    ...defaultResponseState
  },
  uploadPoster: {
    posterStatus: false,
    ...defaultResponseState
  },
  replaceVideo: defaultResponseState,
  saveEmbedStatus: defaultResponseState,
  error: null,
  ...defaultResponseState
};

const hostedVideoReducer: Reducer<HostedVideoState, HostedVideoActions> = (state = initialHostedVideoState, action) => {
  switch (action.type) {
    case getType(hostedVideoActions.getHostedVideoFoldersAsync.request):
    case getType(hostedVideoActions.getHostedVideoFoldersAsync.success):
    case getType(hostedVideoActions.getHostedVideoFoldersAsync.failure):
      return getHostedVideoFoldersReducer(state, action);

    case getType(hostedVideoActions.deleteVideoAsync.request):
    case getType(hostedVideoActions.deleteVideoAsync.success):
    case getType(hostedVideoActions.deleteVideoAsync.failure):
      return deleteVideoReducer(state, action);

    // case getType(hostedVideoActions.createVideoAsync.request):
    // case getType(hostedVideoActions.createVideoAsync.success):
    // case getType(hostedVideoActions.createVideoAsync.failure):
    // case getType(hostedVideoActions.clearCreatedVideo):
    // case getType(hostedVideoActions.createFileError):
    //   return createVideoReducer(state, action);

    // case getType(hostedVideoActions.cancelUpload):
    // case getType(hostedVideoActions.uploadVideoProgress):
    // case getType(hostedVideoActions.uploadVideoAsync.request):
    // case getType(hostedVideoActions.uploadVideoAsync.success):
    // case getType(hostedVideoActions.uploadVideoAsync.failure):
    //   return uploadVideoReducer(state, action);

    case getType(hostedVideoActions.getManifestAsync.request):
    case getType(hostedVideoActions.getManifestAsync.success):
    case getType(hostedVideoActions.getManifestAsync.failure):
      return getManifestReducer(state, action);

    case getType(hostedVideoActions.uploadCustomPosterAsync.request):
    case getType(hostedVideoActions.uploadCustomPosterAsync.success):
    case getType(hostedVideoActions.uploadCustomPosterAsync.failure):
    case getType(hostedVideoActions.triggerPosterStatus):
      return uploadPosterReducer(state, action);

    case getType(hostedVideoActions.replaceVideoAsync.request):
    case getType(hostedVideoActions.replaceVideoAsync.success):
    case getType(hostedVideoActions.replaceVideoAsync.failure):
      return replaceVideoReducer(state, action);

    case getType(hostedVideoActions.saveEmbedStatusAsync.request):
    case getType(hostedVideoActions.saveEmbedStatusAsync.success):
    case getType(hostedVideoActions.saveEmbedStatusAsync.failure):
    case getType(hostedVideoActions.toggleEmbedStatus):
    case getType(hostedVideoActions.changeEmbedType):
    case getType(hostedVideoActions.updateEmbedSizes):
    case getType(hostedVideoActions.updatePopoverEmbed):
    case getType(hostedVideoActions.updateEmbedSizeType):
      return embedVideoReducer(state, action);

    case getType(hostedVideoActions.saveVideoConfigsAsync.request):
    case getType(hostedVideoActions.saveVideoConfigsAsync.success):
    case getType(hostedVideoActions.saveVideoConfigsAsync.failure):
      return saveVideoConfigsReducer(state, action);

    case getType(hostedVideoActions.saveVideoPasswordAsync.request):
    case getType(hostedVideoActions.saveVideoPasswordAsync.success):
    case getType(hostedVideoActions.saveVideoPasswordAsync.failure):
      return saveVideoPasswordReducer(state, action);

    case getType(hostedVideoActions.setVideoData):
    case getType(hostedVideoActions.clearVideoData):
    case getType(hostedVideoActions.updatePoster):
    case getType(hostedVideoActions.updateConfigs):
    case getType(hostedVideoActions.updatePlayerColor):
    case getType(hostedVideoActions.updateVideoPassword):
    case getType(hostedVideoActions.discardPosterChanges):
    case getType(hostedVideoActions.discardConfigsChanges):
    case getType(hostedVideoActions.discardPasswordChanges):
    case getType(hostedVideoActions.discardPlayerColorChanges):
      return videoDataReducer(state, action);

    case getType(hostedVideoActions.checkUploadAsync.request):
    case getType(hostedVideoActions.checkUploadAsync.success):
    case getType(hostedVideoActions.checkUploadAsync.failure):
      return checkUploadReducer(state, action);

    case getType(hostedVideoActions.cleanHostedVideoStore):
      return initialHostedVideoState;

    case getType(hostedVideoActions.toggleNotifications):
      return {
        ...state,
        canNotify: action.payload
      };

    default:
      return state;
  }
};

export default hostedVideoReducer;
